// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rowEmphasised-module_rowContent__tlz0h {
    flex: 1;
    min-width: 0;
    overflow: hidden;
}

.rowEmphasised-module_row__xo1WB {
    display: flex;
    justify-content: flex-start;
    flex-grow: 1;
    overflow: hidden;
    margin-bottom: 4px;

    &:last-child {
        margin-bottom: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Buttons/styles/rowEmphasised.module.css"],"names":[],"mappings":"AAAA;IACI,OAAO;IACP,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;;IAElB;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".rowContent {\n    flex: 1;\n    min-width: 0;\n    overflow: hidden;\n}\n\n.row {\n    display: flex;\n    justify-content: flex-start;\n    flex-grow: 1;\n    overflow: hidden;\n    margin-bottom: 4px;\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rowContent": `rowEmphasised-module_rowContent__tlz0h`,
	"row": `rowEmphasised-module_row__xo1WB`
};
export default ___CSS_LOADER_EXPORT___;
